// Measures rendered text width via a shared, reused canvas context so cell
// renderers can decide layout from the real column width without a post-render
// DOM measurement (no reflow, deterministic for a given font + text).

let context: CanvasRenderingContext2D | null | undefined;

const getContext = (): CanvasRenderingContext2D | null => {
  if (context === undefined) {
    context = document.createElement("canvas").getContext("2d");
  }

  return context;
};

export const measureTextWidth = (text: string, font: string): number => {
  const ctx = getContext();
  if (ctx === null) return 0;

  ctx.font = font;

  return ctx.measureText(text).width;
};
